<script>
import RecognitionDemo from '@/views/APIs/demo/RecognitionDemo'

export default {
    name: 'PassportRecognitionDemo',
    extends: RecognitionDemo,
    data () {
        let fieldList = [
            { name: 'name', label: this.$t('name') },
            { name: 'passport_number', label: this.$t('number') },
            { name: 'pob', label: this.$t('placeOfBirth') },
            { name: 'sex', label: this.$t('gender') },
            { name: 'id_number', label: this.$t('idCardNumber') },
            { name: 'doi', label: this.$t('dateOfIssue') },
            { name: 'doe', label: this.$t('dateOfExpire') }
        ]
        for (let field of fieldList) {
            field.label = this.$filters.capitalize(field.label)
        }
        return {
            model: {
                name: 'xxxxxxxxxx',
                passport_number: 'xxxxxxxxxx',
                sex: 'Nam',
                pob: 'ĐỒNG NAI',
                id_number: 'xxxxxxxxxx',
                doi: '19/03/2018',
                doe: '09/03/2028'
            },
            imageUrl: '/static/img/passport.jpg',
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_PASSPORT_RECOGNITION,
            fieldList: fieldList
        }
    }
}
</script>
